import { render, staticRenderFns } from "./acces-denied-modal.vue?vue&type=template&id=0180cf8c"
import script from "./access-denied-modal.ts?vue&type=script&lang=ts&external"
export * from "./access-denied-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./access-denied-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0180cf8c')) {
      api.createRecord('0180cf8c', component.options)
    } else {
      api.reload('0180cf8c', component.options)
    }
    module.hot.accept("./acces-denied-modal.vue?vue&type=template&id=0180cf8c", function () {
      api.rerender('0180cf8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/access-denied-modal/acces-denied-modal.vue"
export default component.exports